import { render, staticRenderFns } from "./ai-upload-dialog.vue?vue&type=template&id=84124d34&scoped=true"
import script from "./ai-upload-dialog.vue?vue&type=script&lang=js"
export * from "./ai-upload-dialog.vue?vue&type=script&lang=js"
import style0 from "./ai-upload-dialog.vue?vue&type=style&index=0&id=84124d34&prod&lang=scss&scoped=true"
import style1 from "./ai-upload-dialog.vue?vue&type=style&index=1&id=84124d34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84124d34",
  null
  
)

export default component.exports